export const de_DE_formal = {
  translation: {
    hero: {
      title: "Willkommen bei der Werkstatt-Buchung von {{organization}}",
      subtitle: null,
      link: "Zurück zu {{organization}}",
    },
    welcomeModal: {
      title: "Sie verlassen nun die Seite von {{organization}}",
      text: "Bitte beachten Sie, dass Sie sich auf einer Website befinden, für deren Inhalt {{organization}} nicht verantwortlich ist und die Datenschutzbestimmungen von {{organization}} keine Anwendung finden.",
    },
    Werkstatt: "Werkstatt",
    Pruefstelle: "Prüfstelle",
    error:
      "Ups, es gab ein Problem beim Laden der Seite. Bitte laden Sie die Seite neu. Versuchen Sie es in 5 Minuten erneut, falls das Problem weiterhin besteht.",
    "Waehlen Sie einen Service.": "Wählen Sie einen Service.",
    "Waehlen Sie Ihre Marke.": "Wählen Sie Ihre Marke.",
    Antriebsart: "Antriebsart",
    Fahrzeugart: "Fahrzeugart",
    PKW: "PKW",
    Nutzfahrzeug: "Nutzfahrzeug",
    Verbrennungsmotor: "Verbrennungs\u00ADmotor",
    "Elektro-/Hybridmotor": "Elektro-/ Hybridmotor",
    "Waehlen Sie Ihren Wunschort.": "Wählen Sie Ihren Wunschort.",
    "Werkstatt suchen": "Werkstatt suchen",
    "Rueckgabestation suchen": "Rückgabestation suchen",
    additionalgarages: "Weitere Werkstätten",
    chooseSubServices: "Wählen Sie die benötigten Services.",
    chooseTireAmount: "Wählen Sie die Anzahl der Reifen aus.",
    optionalSubservice: "Optional buchbarer Zusatzservice.",
    yes: "Ja",
    no: "Nein",
    benefits: {
      title: "Ihre Vorteile",
      "bullet-point-1": "Freie Termine direkt online buchen",
      "bullet-point-2":
        "Die besten Werkstattpartner auf einem Blick – bewertet nach den Qualitätsstandards von {{organization}}",
      "bullet-point-3": "Exklusive Zusatzservices wie Hol- und Bring und Ersatzfahrzeug hinzufügen",
      feedbackText:
        "Sie haben Anregungen oder etwas funktioniert nicht wie erwartet? Wir würden es gerne erfahren.",
    },
    numberPlateInput: {
      "toggle-to-foreign": "Ausländisches Kennzeichen?",
      "toggle-to-german": "Deutsches Kennzeichen?",
      "free-placeholder": "W-12345 AB",
      "invalid-format": "Bitte geben Sie ein gültiges Kennzeichen ein, z. B. W-12345 AB.",
    },
    contactForm: {
      headline: "Fast geschafft!",
      "sub-headline": "Wie erreichen wir Sie?",
      "address-label": "Wo soll das Auto abgeholt und wieder hingebracht werden?",
      "mileage-label": "Kilometerstand",
      "number-plate-label": "Wie lautet Ihr KFZ-Kennzeichen?*",
      "message-label-required":
        "Bitte teilen Sie der {{garageType}} mit, welches Anliegen Sie haben:*",
      "message-label": "Möchten Sie der {{garageType}} noch etwas mitteilen?",
      "slot-out-of-stock":
        "Ihr gewünschter Termin ist leider inzwischen vergriffen. Bitte suchen Sie sich einen neuen Termin aus.",
      activeInquiryExistsForNumberplateErrorMessage:
        "Sie haben bereits einen Termin für diesen Service und dieses Fahrzeug gebucht. Um fortzufahren, müssen Sie erst Ihren alten Termin stornieren. Stornieren können Sie über einen Link in Ihrer E-Mail zur Auftragsbestätigung oder telefonisch bei repareo unter +49 89 244 182 010.",
      activeInquiryExistsForNumberplateAndServiceErrorMessage:
        "Sie haben bereits einen Termin für diesen Service und dieses Fahrzeug gebucht. Um fortzufahren, müssen Sie erst Ihren alten Termin stornieren. Stornieren können Sie über einen Link in Ihrer E-Mail zur Auftragsbestätigung oder telefonisch bei repareo unter +49 89 244 182 010.",
      submit: "Terminbuchung abschließen",
      submitting: "Anfrage wird gesendet...",
      "mandatory-field-notice": "*Pflichtangaben",
      "notice-bold": "Hinweis:",
      "notice-normal":
        "Ayvens ist Verantwortlicher für die Serviceabwicklung; repareo betreibt diese Buchungsplattform technisch im Auftrag von Ayvens.",
      marketing:
        "Ich möchte Neuigkeiten, Angebote und Aktionen von repareo via Email erhalten. Widerruf jederzeit möglich.",
      adac: "Ich bin ADAC Mitglied und  möchte an der ADAC 3 % Cashback-Action teilnehmen",
      "adac-tip":
        "Als ADAC Mitglied bekommen Sie über repareo 3 % Cashback auf Ihre Werkstatt-Rechnung (Netto). Sobald die Werkstatt eine Rechnung ausgestellt hat, senden Sie uns diese einfach per E-Mail. Wir überweisen Ihnen dann Ihr Geld.",
      "rentalCar-label": "Mietwagenkategorie*",
      claimNumberLabel: "Schadennummer (falls vorhanden)",
      claimNumberLabelRequired: "Schadennummer*",
      claimNumber: {
        label: {
          default: "Schadennummer (falls vorhanden)",
          required: "Schadennummer*",
        },
        placeholder: {
          default: "z.B. 12.345.678/TK25/1",
        },
        hint: {
          default:
            "Sofern Ihnen bereits eine Schadennummer im Format 12.345.678/TK25/1 bekannt ist, geben Sie diese bitte an.",
          required:
            "Die Schadennummer finden Sie in der E-Mail über die Sie unseren Online-Service aufgerufen haben.",
        },
      },
      vinLabel: "Fahrzeug-Identifizierungsnummer (FIN)",
      vinHint:
        "Die FIN steht in der Zulassungsbescheinigung Teil I (Fahrzeugschein Feld 'E') und Teil II (Fahrzeugbrief). Sie existiert auch 'physisch' und meist mehrfach am Fahrzeug selbst etwa an der B-Säule des Türrahmens, also zwischen Vorder- und Hintertür, in der Fahrertür, im Motor- und Kofferraum, unter der Motorhaube oder auf dem Armaturenbrett.",
      vinInvalidHint:
        "Die Buchstaben I, O, Q sind nicht erlaubt. Wahrscheinliche Verwechslung mit den Zahlen 1 oder 0.",
      contractNumber: { label: "Vertragsnummer", placeholder: "123ABC" },
      placeholders: {
        "first-name": "Vorname*",
        "last-name": "Nachname*",
        email: "E-Mail*",
        phone: "Telefonnummer für Rückfragen*",
        street: "Strassenname und Hausnummer",
        postcode: "Postleitzahl",
        city: "Wohnort",
        addition: "Adresszusatz",
        message: "Anmerkungen (optional)",
        "message-required": "Anmerkungen",
      },
      validationErrors: {
        "first-name": "Bitte geben Sie Ihren Vornamen an.",
        "last-name": "Bitte geben Sie Ihren Nachnamen an.",
        email: "Bitte geben Sie eine gültige E-Mail-Adresse an.",
        phone: "Bitte geben Sie eine gültige Telefonnummer an.",
        "number-plate": "Bitte geben Sie das Kfz-Kennzeichen Ihres Fahrzeuges an.",
        mileage: "Bitte geben Sie den Kilometerstand Ihres Fahrzeuges an.",
        message: "Bitte geben Sie Ihr Anliegen an.",
        tos: "Bitte akzeptieren Sie unsere Nutzungsbedingungen und Datenschutzerklärung.",
        postcode: "Die Postleitzahl darf nur Ziffern enthalten.",
      },
      numberCheck: {
        title: "Kennzeichen korrekt?",
        text: "Bitte gehen Sie sicher, dass Ihr Kennzeichen korrekt ist: {{numberplate}}.",
      },
      benefits: {
        "benefit-1": "Kostenfreie Stornierung",
        "benefit-2": "Alle Infos per E-Mail",
      },
      vehicleReturn: {
        submit: "Terminanfrage absenden",
      },
      reviewOptIn: {
        label:
          "Ich willige ein, einmalig per E-Mail zu einer Fahrerbefragung kontaktiert zu werden.",
      },
    },
    contact: {
      title: "Kontakt",
      text: "Haben Sie Fragen zur Buchung? Lilly steht Ihnen zur Seite.",
      reachability: "8 - 18 Uhr | Montag - Freitag",
      email: {
        label: "E-Mail",
        link: "mailto:werkstattmeister@repareo.de",
        title: "werkstattmeister@repareo.de",
      },

      phone: {
        label: "Telefon",
        link: "tel:004989244182010",
        title: "+49 89 244 182 010",
      },
    },
    keyNumber: {
      headline: "Geben Sie hier Ihre Fahrzeugschein-Daten ein.",
      submit: "Bestätigen",
      "to-brand": "oder gehen Sie zurück zur",
      "brand-selection": "Markenauswahl",
    },
    keyNumberApproval: {
      headline: "Ist das Ihr Fahrzeug?",
      error:
        "Wir konnten leider kein passendes Fahrzeug finden. Bitte nutzen Sie die Marken- und Modellauswahl.",
      "no-vehicle-found": "Kein Fahrzeug gefunden",
      "no-vehicle-found-tip":
        "Bitte korrigieren Sie Ihre Angaben oder benutzen Sie die Markenauswahl.",
    },
    location: {
      headline: "Wo suchen Sie eine Werkstatt?",
      subheadline:
        "Stundensätze variieren stark nach Region, daher fragen wir die Postleitzahl ab.",
      submit: "Weiter",
    },
    brand: {
      headline: "Welche Marke fahren Sie?",
      "skip-steps": "oder überspringen Sie die ersten 3 Schritte mit den Daten aus Ihrem ",
      "vehicle-registration": "Fahrzeugschein",
    },
    brandList: {
      "search-brand": "Suchen Sie hier nach Ihrer Marke",
      "important-brands": "Häufige Marken",
      "show-all-brands": "Alle Marken anzeigen",
    },
    generation: {
      "choose-model": "Wählen Sie Ihr {{brand}} Modell",
      "skip-steps": "oder überspringen Sie die ersten 3 Schritte mit den Daten aus Ihrem ",
      "vehicle-registration": "Fahrzeugschein",
    },
    generationList: {
      "search-generation": "Suchen Sie hier nach Ihrem Modell",
    },
    bodies: {
      headline: "Bauform wählen",
      subheadline:
        "Sie wissen nicht genau, was Sie hier anklicken sollen? Dann lassen Sie die Felder einfach frei.\n" +
        "                        Die Werkstatt wird Ihnen auf Basis Ihres Fahrzeuges einen\n" +
        "                        Kostenvoranschlag erstellen.",
      submit: "Weiter",
    },
    gearbox: {
      headline: "Wählen Sie Ihr Getriebe:",
      subheadline: "Je nach Getriebe können Inspektionsintervalle unterschiedlich ausfallen.",
    },
    equipment: {
      headline: "Wählen Sie Ihre Ausstattungsmerkmale:",
      subheadline:
        "Sie wissen nicht genau, was Sie hier anklicken sollen? Dann lassen Sie die Felder einfach frei.\n" +
        "                        Die Werkstatt wird Ihnen auf Basis Ihres Fahrzeuges einen\n" +
        "                        Kostenvoranschlag erstellen.",
      submit: "Weiter",
    },
    motorization: {
      headline: "Welchen Motor hat Ihr {{brand}} - {{generation}}:",
      "skip-steps": "oder überspringen Sie die ersten 3 Schritte mit den Daten aus Ihrem ",
      "vehicle-registration": "Fahrzeugschein",
    },
    motorizationList: {
      "fuel-type": "Kraftstoff:",
    },
    registrationDate: {
      headline: "Erstzulassung",
      submit: "Weiter",
      description:
        "Auch die Erstzulassung wird bei vielen Modellen im Serviceintervall mit einbezogen.",
    },
    mileage: {
      headline: "Kilometerstand wählen",
      subheadline: "Je nach Kilometerstand ist ein anderer Service fällig.",
      submit: "Weiter",
    },
    submit: {
      headline: "Erhalten Sie jetzt Ihren gratis Kostenvoranschlag:",
      email: "E-Mail Adresse",
      phone: "Rufnummer (optional)",
      button: "<b>Einschätzung erhalten</b> <br/>Kostenlos und unverbindlich",
      "benefit-1": "Detaillierte Kalkulation auf Herstellervorgaben (Teile, was wird gemacht etc.)",
      "benefit-2":
        "Zugang zu richtig guten Werkstätten mit Preiseinschätzungen zu Ihrem angefragten Service",
      "benefit-3": "Online Terminvereinbarung",
    },
    summary: {
      text: "Vielen Dank, Ihre Terminbuchung ist erfolgreich bei uns eingegangen. Sie erhalten die finale Bestätigung separat per E-Mail.",
      "contact-us-repareo":
        "Sollten Sie Fragen zu Ihrer Terminbuchung haben, können Sie uns per Telefon oder E-Mail erreichen.",
      "contact-us-partner":
        "Sollten Sie Fragen zu Ihrer Terminbuchung haben, können Sie repareo per Telefon oder E-Mail erreichen.",
      vehicleReturn: {
        text: "Vielen Dank, Ihre Terminanfrage ist erfolgreich eingegangen. Sie erhalten die finale Bestätigung separat per E-Mail.",
        "contact-us-partner":
          "Sollten Sie Fragen zu Ihrem Termin haben, können Sie repareo per Telefon oder E-Mail erreichen.",
      },
    },
    profileHeader: {
      "checked-by": "geprüft durch {{organization}}",
      rating: "Weiterempfehlung",
      "no-reviews": "Noch keine Bewertung",
      "nationwide-service-1": "Mobiler Service (deutschlandweit)",
      "nationwide-service-1_AT": "Mobiler Service (österreichweit)",
      "nationwide-service-2": "Diese Werkstatt kommt zu Ihnen nach Hause",
    },

    booking: {
      headline: "Termin buchen",
      subheadline: "Service(s): {{service}}",
      "slot-taken-1": "Schade! Da war leider jemand schneller und hat Ihren Wunschtermin am",
      "slot-taken-2": "reserviert. Bitte wählen Sie einen anderen Termin.",
      "no-slots": "Leider sind für diese Werkstatt aktuell keine freien Termine verfügbar.",
      "no-slots-contact-phone": `Bitte kontaktieren Sie die Werkstatt direkt unter <tel>{{tel}}</tel>.`,
      "error-nearest-slot-gone":
        "Puh, die Werkstatt hat einiges zu tun: Der {{ day }} ist jetzt schon ausgebucht. Ab dem {{ newDay }} sind wieder Termine frei.",
      "next-free-slot": "Nächster freier Termin:",
      "chosen-slot": "Ausgewählter Termin:",
      "please-choose-services": "Bitte wählen Sie die gewünschten Services",
      "more-information-link": "Mehr zum Terminablauf",
      hint: "Finale Terminbestätigung erfolgt durch die Prüfstelle.",
      blocking: "Termin wird reserviert...",
      submit: "Termin sichern",
      requestCallback: "Rückruf anfordern",
      moreInformation: {
        headline: "Wie genau läuft der Termin ab?",
        "bullet-point-1": "Ihre Buchung geht direkt in den Kalender der {{garageType}}.",
        "bullet-point-2": "Bitte geben Sie Ihr Auto zu Beginn des Termins ab.",
        "bullet-point-3":
          "Die {{garageType}} informiert Sie telefonisch, sobald Sie Ihr Auto abholen können.",
        "bullet-point-4": "Sie können ihren Termin jederzeit kostenfrei absagen.",
        "bullet-point-5": "",
        "bullet-point-6": "",
        "instant-booking":
          "Diese Werkstatt erhält Ihren gebuchten Termin direkt in den Kalender. Somit ist der Termin sofort bestätigt.",
        "request-booking":
          "Diese Werkstatt erhält eine Terminanfrage und bestätigt Ihren Wunschtermin so schnell wie möglich.",
      },
      calendarDisclaimer: "",
      vehicleReturn: {
        headline: "Termine",
        submit: "Termin auswählen",
      },
    },

    checkout: {
      orderSummary: {
        headline: "Terminübersicht",
      },
    },

    profileDetails: {
      headline: "Weitere Infos zur {{garageType}}",
      "opening-hours": "Öffnungszeiten",
      description: "Beschreibung",
      "default-description":
        " Willkommen auf der repareo-Profilseite von {{garage}}. Diese {{garageType}} hat\n" +
        "                            leider selbst noch keine weiteren Informationen auf repareo hinterlegt. Sie können dennoch\n" +
        '                            jederzeit über "Termin sichern" rechts oben einen Termin bei dieser {{garageType}} über repareo\n' +
        "                            buchen.",
      "description-disclaimer":
        "Die folgende Beschreibung richtet sich an Privatkunden der {{garageType}}. Als Nutzer eines {{organization}} Fahrzeugs sind ggf. nicht alle genannten Services erhältlich.",
      days: {
        monday: "Montag",
        tuesday: "Dienstag",
        wednesday: "Mittwoch",
        thursday: "Donnerstag",
        friday: "Freitag",
        saturday: "Samstag",
        sunday: "Sonntag",
      },
    },

    reviews: {
      rating: {
        overall: "Gesamtbewertung",
        rating: "Weiterempfehlung",
        reference: "Basierend auf repareo und Google Nutzern",
        cleanliness: "Sauberkeit und Erscheinungsbild",
        quality: "Qualität der erbrachten Leistung",
        punctuality: "Termintreue",
        competence: "Transparenz und Beratung",
        kindness: "Freundlichkeit der Mitarbeiter",
      },
      "customer-ratings": "Bewertungen von repareo-Kunden",
      "show-less": "Weniger anzeigen",
      "show-more": "Mehr Bewertungen anzeigen",
      "more-reviews": "Weitere Bewertungen",
    },
    brakeScope: {
      headline: "Welchen Umfang soll der Bremsenwechsel haben?",
      "choose-multiple": "Mehrfachauswahl möglich",
      "front-axle": "Vorderachse",
      "rear-axle:": "Hinterachse",
      submit: "Weiter",
    },
    vehicleDelivery: {
      "identity-headline": "Haustürlieferung terminieren",
      "identity-text":
        "Bitte identifizieren Sie sich zunächst über die Leasingvertragsnummer, um Ihre Wunschtermine und den Lieferort festzulegen.",
      "identity-name": "Nachname",
      "identity-agreement-number": "Leasingvertragsnummer",
      "identity-button": "Zur Lieferung",
      "identity-error-contract":
        "Die Vertragsnummer ist nicht korrekt. Bitte prüfen Sie diese und versuchen es erneut.",
      "identity-error-lastName":
        "Der Nachname entspricht nicht dem für diese Vertragsnummer hinterlegtem Namen. Bitte prüfen Sie diesen und versuchen es erneut.",
      "identity-error-not-yet-possible":
        "Das Fahrzeug ist nicht zur Lieferung bereit. Bitte kontaktieren Sie auslieferung@mobility-concept.de.",
      "identity-error-wish-already-set":
        "Es wurde bereits eine Lieferung beantragt. Bitte kontaktieren Sie auslieferung@mobility-concept.de für gewünschte Änderungen.",
      "details-headline": "Lieferung",
      "details-address-headline": "Lieferdetails",
      "details-date-headline": "Liefertermin",
      "details-modal-headline": "Lieferdetails ändern",
      "details-modal-text":
        "Hier können Sie einen neuen Empfänger und eine neue Adresse angeben zu der das Fahrzeug geliefert werden soll. <br/><br/>Falls Sie das Fahrzeug nicht selbst entgegennehmen können, haben Sie die Möglichkeit, eine bevollmächtigte Person anzugeben.",
      "details-modal-name": "Name",
      "details-modal-street": "Straße & Hausnummer",
      "details-modal-postcode": "Postleitzahl",
      "details-modal-city": "Ort",
      "details-modal-hint":
        "Hinweis: Bitte beachten Sie, dass Änderungen an der Lieferadresse und dem Wunschtermin nach deren Eingabe nur gegen eine Gebühr vorgenommen werden können.",
      "details-modal-cancel": "Abbrechen",
      "details-modal-accept": "Übernehmen",
      "details-date-text":
        "Bitte geben Sie 3 mögliche Tage an, an denen das Fahrzeug an der oben genannten Adresse entgegen genommen werden kann. Der erste auswählbare Tag ist der frühestmögliche Abholtermin.",
      "details-date-1": "Terminwunsch 1",
      "details-date-2": "Terminwunsch 2",
      "details-date-3": "Terminwunsch 3",
      "details-hint": "Ich finde keinen passenden Termin",
      "details-hint-accepted": "Es wurden weitere Termine in den Kalender freigegeben",
      "details-button": "Zur Zusammenfassung",
      "submit-headline": "Zusammenfassung",
      "submit-identity-headline": "Leasingvertragsnummer:",
      "submit-address-headline": "Lieferadresse:",
      "submit-date-headline": "Mögliche Liefertermine:",
      "submit-text":
        "Nach dem Klick auf “Haustürlieferung beantragen”, erhalten Sie in den nächsten Tagen eine Bestätigung Ihres Liefertermins.<br/><br/>Hiermit bestätige ich verbindlich den o.g.  Wunschort für die Zustellung. Eine Änderung zu einem späteren Zeitpunkt ist nicht mehr möglich.<br/><br/>Es können Kosten gem. der AGB entstehen",
      "submit-button": "Haustürlieferung beantragen",
      "summary-headline": "Danke, Haustürlieferung beantragt!",
      "summary-text-1":
        "Sie werden in den nächsten Tagen eine Bestätigung Ihres Liefertermins erhalten.",
      "summary-text-2": `Bei Fragen wenden Sie sich bitte per E-Mail an: <a href="mailto:auslieferung@mobility-concept.de">auslieferung@mobility-concept.de</a>`,
      "submit-error": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    },
    hint: {
      text: "Alle gezeigten Werkstätten sind offizielle {{organization}} Service-Partner.",
      "repareo-inspection-text":
        "Alle gezeigten Werkstätten führen die Inspektion nach Herstellervorgaben durch und erhalten Ihre Gewährleistung.",
    },
    // garage list
    "In wenigen Schritten zur Werkstattuebersicht": "In wenigen Schritten zur Werkstattübersicht",
    "Werkstaetten in Ihrer Naehe": "{{service}}: Werkstätten in Ihrer Nähe",
    "Pruefstellen in Ihrer Naehe": "{{service}}: Prüfstellen in Ihrer Nähe",
    "Partnerwerkstaetten in Ihrer Naehe": "{{organization}} Partnerwerkstätten in Ihrer Nähe",
    "Partnerpruefstellen in Ihrer Naehe": "{{organization}} Partnerprüfstellen in Ihrer Nähe",
    "sort by": "Sortieren nach",
    Listenansicht: "Listenansicht",
    Kartenansicht: "Kartenansicht",
    Umgebung: "Umgebung",
    Verfuegbarkeit: "Verfügbarkeit",
    Zusatzservices: "Zusatzservices",
    "Suche speichern": "Suche speichern",
    "proximity-search-text":
      "Geben Sie hier Ihren Standort ein, z.B. Ihre Postleitzahl oder Stadt.",
    Datum: "Datum",
    "Werkstattname suchen": "Werkstattname suchen",
    Marke: "Marke",
    garageList: {
      "no-availability": "Details erfahren",
      sorting: {
        earliest_slot: "Frühester Termin",
        smallest_distance: "Geringste Entfernung",
        shortest_travel_time: "Kürzeste Fahrzeit",
        cheapest_price: "Günstigster Preis",
        best_reviewed: "Beste Bewertung",
        recommended: "Empfehlung",
        partner_recommended: "Standard",
      },
      emptyState: {
        headline: "Wir haben leider keine Werkstatt in Ihrer Nähe gefunden.",
        description:
          "Wir sind bemüht, unser Netzwerk an Werkstätten und Prüfstellen, die direkt über repareo gebucht werden können, " +
          "ständig zu erweitern. Aktuell haben wir in Ihrer Nähe leider noch keine buchbare Werkstatt für Ihren " +
          "Service. Bei Fragen steht Ihnen unsere Buchungshotline jederzeit zur Verfügung.",
        "bullet-point-1": "",
        "bullet-point-2": "",
      },
      filters: {
        premiumServices: {
          "additional-cost-info": "*ggf. können zusätzliche Kosten anfallen.",
          "additional-cost-infoTireStorageList":
            "*Einlagerung auf eigene Kosten. Abschließende Kosten werden vor Ort in Rechnung gestellt.",
          "additional-cost-infoTireStorageDetail":
            "*Einlagerung auf eigene Kosten. Die Einlagerung ist nicht Bestandteil Ihres Vertrages. Abschließende Kosten werden vor Ort in Rechnung gestellt.",
          "additional-cost-mightNotBeInContract":
            "*Falls nicht im Vertrag enthalten, können zusätzliche Kosten anfallen.",
        },
      },
      badges: {
        "best-reviewed-hint": "Beste Bewertungen basieren auf Daten von repareo und Google Nutzern",
      },
      promotion: {
        discountPrefix: {
          max: "max",
          min: "min",
          from: "ab",
          monthly_from: "mtl. ab",
        },
      },
      gotoAppointmentselect: "Zur Terminauswahl",
      showPhoneNumber: "Telefonnummer anzeigen",
      serviceLocation: "Service-Standort",
      mobileService: "mobiler Service (deutschlandweit)",
      mobileService_AT: "mobiler Service (österreichweit)",
      nextAppointment: "Nächster Termin:",
      notBookable: "Nicht online buchbar",
    },
    hotline: {
      "hotline-headline": "Ihre Buchungshotline",
      "hotline-phone-link": "tel:004989244182010",
      "hotline-phone": "+49 89 244182010",
      "hotline-availability": "Montag - Freitag 8 - 18 Uhr",
      "hotline-via-email": "Erfrage Termine alternativ auch gern per Mail an: ",
      "hotline-via-email-email": "werkstattmeister@repareo.de",
    },
    login: {
      title: "Anmeldung",
      subtitle: "Melden Sie sich mit ihrem repareo Account an, um eine Buchung durchzuführen.",
      eMail: "E-Mail",
      password: "Passwort",
      signIn: "Jetzt anmelden",
      validations: {
        email: {
          required: "Bitte geben Sie  Ihre E-Mail Addresse an.",
          invalid: "Bitte geben Sie eine gültige E-Mail Addresse an.",
        },
        password: {
          required: "Bitte geben Sie Ihr Passwort an.",
          minLength: "Das Passwort muss mindestens 8 Zeichen lang sein.",
        },
        failedLogin: "Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Zugangsdaten.",
      },
    },
    vehicleSelector: {
      title: "Für welches Fahrzeug soll gebucht werden?",
      numberPlate: "Kennzeichen",
      searchNumberPlate: "Kennzeichen suchen",
      backToNumberPlateSelection: "Zurück zur Suche",
      isRightVehicle: "Ist dies das richtige Fahrzeug?",
      contractNumber: "Vertragsnummer",
      submit: "Fahrzeug auswählen",
      vehicleSelector: {
        validation: {
          errors: {
            error: {
              unauthorized: "Sie haben keine Berechtigung",
              not_found: "Zu diesem Kennzeichen wurde kein Fahrzeug gefunden",
              vehicle_too_heavy: "Das Fahrzeug ist zu schwer. Das Maximalgewicht beträgt 3500 kg",
              contract_number_mismatch: "Etwas ist schiefgelaufen",
              invalid_request: "Etwas ist schiefgelaufen",
            },
          },
        },
      },
    },
    vehicleReturn: {
      addressModal: {
        headline: "Abholdetails ändern",
        description:
          "Hier können Sie eine neue Kontaktperson und eine neue Adresse angeben von der das Fahrzeug abgeholt werden soll. <br/><br/>Falls Sie das Fahrzeug nicht selbst übergeben können, haben Sie die Möglichkeit, eine bevollmächtigte Person anzugeben.",
        name: {
          label: "Name",
        },
        phone: {
          label: "Telefon",
        },
        email: {
          label: "E-Mail",
          invalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
        },
        street: {
          label: "Straße & Hausnummer",
        },
        postcode: {
          label: "Postleitzahl",
        },
        city: {
          label: "Ort",
        },
        hint: "Hinweis: Bitte beachten Sie, dass Änderungen an der Abholadresse und dem Wunschtermin nach deren Eingabe nur gegen eine Gebühr vorgenommen werden können.",
        cancelButton: {
          label: "Abbrechen",
        },
        acceptButton: {
          label: "Übernehmen",
        },
      },
      "identity-headline": "Kundenlogin",
      "identity-text":
        "Bitte identifizieren Sie sich zunächst über die Leasingvertragsnummer, um die Abholung Ihres Fahrzeuges zu beantragen",
      "identity-name": "Nachname",
      "identity-agreement-number": "Leasingvertragsnummer",
      "identity-button": "Zur Abholung",
      "summary-headline": "Danke, Abholung beantragt!",
      "summary-text-1":
        "Sie werden in den nächsten Tagen eine Bestätigung Ihres Abholtermins erhalten.",
      "summary-text-2": `Bei Fragen wenden Sie sich bitte per E-Mail an: <a href="mailto:abholung@santander.de">abholung@santander.de</a>`,
      "details-headline": "Abholung",
      "details-address-headline": "Abholadresse",
      "details-date-headline": "Abholdatum",
      "details-email-invalid": "Bitte geben Sie eine gültige E-Mail Adresse ein.",
      "details-modal-headline": "Abholdaten ändern",
      "details-date-text":
        "Bitte geben Sie 3 mögliche Tage an, an denen das Fahrzeug an der oben genannten Adresse abgeholt werden kann.",
      "details-date-1": "Option 1",
      "details-date-2": "Option 2",
      "details-date-3": "Option 3",
      "details-button": "Zur Zusammenfassung",
      "submit-headline": "Zusammenfassung",
      "submit-identity-headline": "Leasingvertragsnummer:",
      "submit-address-headline": "Abholadresse:",
      "submit-email-headline": "E-Mail-Adresse:",
      "submit-date-headline": "Mögliche Abholtermine:",
      "submit-text":
        'Nach dem Klick auf "Abholung beantragen", erhalten Sie in den nächsten Tagen eine Bestätigung Ihres Abholtermins.<br/><br/>Hiermit bestätige ich verbindlich den o.g.  Wunschort für die Abholung. Eine Änderung zu einem späteren Zeitpunkt ist nicht mehr möglich.',
      "submit-button": "Kostenpflichtige Abholung beantragen",
      "details-cost-accept":
        "Hiermit bestätige ich, dass die Fahrzeugabholung kostenpflichtig ist und akzeptiere die damit verbundenen Kosten gemäß der ausgewiesenen Preisangabe.",
      errors: {
        noData:
          "Vertragsdaten oder Wunsch-Rückgabedaten fehlen. Bitte starten Sie den Prozess von vorne.",
      },
    },
    contractDetails: {
      error: {
        general: `Etwas ist schiefgegangen. Bitte schreiben Sie eine E-Mail an <a>werkstattmeister@repareo.de</a>`,
        not_found:
          "Wir konnten anhand Ihrer Vertragsdaten keinen Vertrag finden. Bitte überprüfen Sie Ihre Vertragsdaten.",
        does_not_match:
          "Die eingegebenen Daten passen nicht zum gefundenen Vertrag. Bitte überprüfen Sie Vertragsnummer und Kennzeichen.",
        wrong_contract_type:
          "Ihr Vertrag kann über diese Seite nicht zurückgegeben werden. Bitte überprüfen Sie Ihre Vertragsdaten.",
      },
    },
    checkpointDetails: {
      "regulated-info":
        "Fahrzeuguntersuchungen sind in Deutschland genau geregelt. Die Tätigkeit von Prüfgesellschaften ist streng reglementiert und wird durch die staatlichen Aufsichtsbehörden kontrolliert, um die Qualität und die Unabhängigkeit der vorgenommenen Prüfungen zu gewährleisten.",
      "regulated-info_AT":
        "Fahrzeuguntersuchungen sind in Österreich genau geregelt. Die Tätigkeit von Prüfgesellschaften ist streng reglementiert und wird durch die staatlichen Aufsichtsbehörden kontrolliert, um die Qualität und die Unabhängigkeit der vorgenommenen Prüfungen zu gewährleisten.",
    },
  },
};
